export default __webpack_public_path__ + "static/ice_machine_w.f032198e693dc48bb7899aa06ed78d76.svg";